import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UrlService } from 'app/core/http/url.service';
import { IGameShowFeedbackType } from 'app/student/game-show/types/IGameshowFeedbackType';
import { IGameQuestion } from 'app/student/models/game-question';
import { LaunchGameShowRequest } from 'app/teacher/game-show/models/launch-game-show-request.model';
import { LaunchGameShowResponse } from 'app/teacher/game-show/models/launch-game-show-response.model';
import { GameShowQuestionModel } from 'app/teacher/models/game-show-question.model';
import { GameShowState } from '../models/game-show-state.model';

@Injectable({
  providedIn: 'root'
})
export class GameShowDataService {
  readonly httpClient = inject(HttpClient);
  readonly urlService = inject(UrlService);

  public launchGameShow(publicUnitId: string, request: LaunchGameShowRequest): Observable<LaunchGameShowResponse> {
    const url = this.urlService.buildServerApiUrl('teacher', 'gameShow', publicUnitId, 'launch');

    return this.httpClient.post<LaunchGameShowResponse>(url, request);
  }

  public getQuestionContentTeacher(questionId: string): Observable<GameShowQuestionModel> {
    const url = this.urlService.buildServerApiUrl('teacher', 'QuestionContent', questionId);

    return this.httpClient.get<GameShowQuestionModel>(url);
  }

  public getQuestionContentStudent(questionId: string): Observable<GameShowQuestionModel> {
    const url = this.urlService.buildServerApiUrl('student', 'QuestionContent', questionId);

    return this.httpClient.get<GameShowQuestionModel>(url);
  }

  public getGameShow(activityId: string): Observable<GameShowState> {
    const url = this.urlService.buildServerApiUrl('student', 'game-show', activityId);
    return this.httpClient.get<GameShowState>(url);
  }

  public getSurveyFeedbackStudent(activityId: string): Observable<IGameShowFeedbackType[]> {
    const url = this.urlService.buildServerApiUrl('student', 'game-show', activityId, 'feedback-types');
    return this.httpClient.get<IGameShowFeedbackType[]>(url);
  }

  public sendFeedbackTeacher(activityId: string, score: number, comments: string): Observable<void> {
    const url = this.urlService.buildServerApiUrl('teacher', 'game-show', activityId, 'feedback');
    return this.httpClient.post<void>(url, { score, comments });
  }

  public teacherLikeSurvey(unitId: string): Observable<void> {
    const url = this.urlService.buildServerApiUrl('Teacher', 'Unit', unitId, 'Like');
    return this.httpClient.put<void>(url, {});
  }

  public teacherUnlikeSurvey(unitId: string): Observable<void> {
    const url = this.urlService.buildServerApiUrl('Teacher', 'Unit', unitId, 'Like');
    return this.httpClient.delete<void>(url);
  }

  public convertToGameshowQuestion(question: GameShowQuestionModel): IGameQuestion {
    return { ...question,
      AttemptItemOrder: 1,
      DisplayUploadFocus: false,
      GoalId: '',
      IsUploadFocus: false,
      IsAnswerInline: false,
      SubmittedChoices: [],
      UploadFocusInstructions: '',
      NumAnswers: 0,
      VideoId: '',
      IsSolutionSubmitted: false,
      AttemptNumber: 1,
      NumberOverride: '',
      ContentSlides: { Before: [], After: [] }
    };
  }
}
